import { useDispatch } from "react-redux";

import { getSettingsAction } from "../redux/actions";
import useCurrentUser from "./useCurrentUser";

const useGetSettings = () => {
  const dispatch = useDispatch();
  const { user } = useCurrentUser();

  if (user.id) {
    dispatch(getSettingsAction());
  }
};

export default useGetSettings;
